<div *ngIf="orderData.rules?.guarantee_id == 'w'">
  <form [formGroup]="guaranteeForm">
    <div class="row">
      <div
        *ngIf="guaranteeForm.dirty && !guaranteeForm.value.guarantee_id"
        class="alert alert-warning alert-sm mt-2"
      >
        <small>
          <i class="icon-info"></i>
          {{ "swal_messages.guarantee_marked_for_removal" | translate }}
        </small>
      </div>
      <div class="col-6">
        <div class="column-list">
          <label for="guarantee" class="form-label">
            {{ "inputs.guarantee" | translate }}
          </label>
          <div class="input-group div-copy">
            <div
              class="selector-container-supplier form-control position-relative"
              [ngClass]="{
                expanded: optionsVisibleGuarantee,
                'disabled-select': isGuaranteeInputDisabled
              }"
            >
              <input
                type="text"
                (focus)="onFocus('guarantee')"
                (blur)="hideOptions()"
                placeholder="{{ 'inputs.guarantee' | translate }}"
                (input)="searchClients($event.target)"
                [value]="displayTextGuarantee"
                [disabled]="isGuaranteeInputDisabled"
                class="w-100 border-0 outline-none bg-transparent"
              />
              <input type="hidden" formControlName="guarantee_id" />
              <span class="icon-chevron-down arrow"></span>

              <!-- Dropdown -->
              <div
                class="options-container-guarantee"
                *ngIf="optionsVisibleGuarantee"
                [ngClass]="{ visible: optionsVisibleGuarantee }"
              >
                <div
                  class="option-value"
                  *ngFor="let client of filteredGuarantee"
                  (mousedown)="onSelectGuarantee(client)"
                >
                  <div>
                    {{ client.name }}
                    {{ client.lastname ? client.lastname : "" }}
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="client_selector_spinner"
              class="spinner-border text-info"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>

            <div *ngIf="orderData?.guarantee" class="input-group-append">
              <button
                type="button"
                class="btn btn-sm"
                (click)="removeGuarantee()"
              >
                <i class="icon-trash text-danger"></i>
              </button>
            </div>
          </div>

          <label
            *ngIf="!orderData.guarantee"
            for="client"
            class="text_add"
            (click)="openClientForm('guarantee')"
          >
            {{ "inputs.new_client" | translate }}
          </label>
        </div>
      </div>

      <div class="col-6">
        <div class="column-list">
          <label for="guarantee_relationship" class="form-label">{{
            "inputs.guarantee_relationship" | translate
          }}</label>
          <div class="input-group div-copy">
            <input
              type="text"
              class="form-control"
              id="guarantee_relationship"
              required
              formControlName="guarantee_relationship"
              placeholder="{{ 'inputs.guarantee_relationship' | translate }}"
            />
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div *ngIf="orderData.guarantee">
  <div class="row" [hidden]="orderData.guarantee && step == 2">
    <div class="col-6">
      <div class="column-list">
        <label>{{ "inputs.guarantee" | translate }}</label>
        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="
              orderData.guarantee?.name + ' ' + orderData.guarantee?.lastname
            "
            #inputClientName
          />

          <div class="input-group-append">
            <a *ngIf="orderData.guarantee && account_type == 'broker'"
              [href]="goClientForm(orderData.guarantee.reference)"
              class="btn btn-outline-secondary copy"
              [title]="'forms.names.editClient' | translate">
              <i class="icon-pencil"></i>
            </a>
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="copyToClipboard(inputClientName.value, $event)"
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
        <div class="input-group justify-content-end">
          <div class="clear">
            <button
              *ngIf="orderData.guarantee?.assignee"
              class="btn btn-hover clear-button ml-15"
              type="button"
              (click)="openAssigneeForm()"
            >
              {{ "inputs.see_assignee" | translate }}
              {{ orderData.guarantee?.assignee.name }}
              <i class="icon-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="column-list">
        <label>{{ "inputs.identification" | translate }}</label>
        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.guarantee?.tax_id"
            #inputFieldtax_id
          />

          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="copyToClipboard(inputFieldtax_id.value, $event)"
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="column-list">
        <label>{{ "inputs.contact" | translate }}</label>

        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.guarantee?.email"
            #inputFieldemail
          />

          <div class="input-group-append">
            <button *ngIf="orderData.guarantee?.email"
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="openMailModal(orderData.guarantee.reference)"
              [title]="'buttons.send_mail' | translate"
            >
              <i class="icon-envelope"></i>
            </button>
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="copyToClipboard(inputFieldemail.value, $event)"
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
        <label>{{ "inputs.phone" | translate }}</label>

        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.guarantee?.phone"
            #inputFieldphone
          />
          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="
                copyToClipboard(
                  extractPhoneNumber(inputFieldphone.value),
                  $event
                )
              "
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="column-list">
        <label for="guarantee_relationship" class="form-label">{{
          "inputs.guarantee_relationship" | translate
        }}</label>

        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData?.guarantee_relationship"
            #inputgGarantee_relationship
          />

          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="
                copyToClipboard(inputgGarantee_relationship.value, $event)
              "
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>

        <label>{{ "inputs.direction" | translate }}</label>

        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.guarantee?.billing_address"
            #inputFieldbilling_address
          />

          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="copyToClipboard(inputFieldbilling_address.value, $event)"
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>

        <label>{{ "inputs.billing_postal_code" | translate }}</label>

        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.guarantee?.billing_postal_code"
            #inputFieldbilling_postal_code
          />

          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="
                copyToClipboard(inputFieldbilling_postal_code.value, $event)
              "
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
        <label>{{ "inputs.billing_state" | translate }}</label>

        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.guarantee?.billing_state"
            #inputFieldbilling_state
          />

          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="copyToClipboard(inputFieldbilling_state.value, $event)"
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
        <label>{{ "inputs.billing_city" | translate }}</label>

        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.guarantee?.billing_city"
            #inputFieldbilling_city
          />

          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="copyToClipboard(inputFieldbilling_city.value, $event)"
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
        <div class="input-group justify-content-end mt-2">
          <button
            type="submit"
            class="btn btn-primary d-flex align-items-center gap-2"
            (click)="step = 2"
          >
            {{ "inputs.next" | translate }}
            <i class="icon-arrow-right btn-next"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div [hidden]="orderData.guarantee && step == 1">
    <form [formGroup]="guaranteeFormExtra">
       <div class="row">
        <div class="col-6">
          <div class="column-list">
            <label for="guarantee_gender" class="form-label">{{ "inputs.guarantee_gender" | translate }}</label>
            <ng-select
              formControlName="guarantee_gender"
              [items]="genderOptions"
              bindValue="key"
              [placeholder]="'inputs.select_option' | translate"
              [searchable]="true"
              [clearable]="false"
              [notFoundText]="'tables.no_results' | translate"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ "inputs.gender." + item.key | translate }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ "inputs.gender." + item.key | translate }}
              </ng-template>
            </ng-select>
            <label for="guarantee_housing_type" class="form-label">{{ "inputs.guarantee_housing_type" | translate }}</label>

            <ng-select
              formControlName="guarantee_housing_type"
              [items]="housingTypeOptions"
              bindValue="key"
              [placeholder]="'inputs.select_option' | translate"
              [searchable]="true"
              [clearable]="false"
              [notFoundText]="'tables.no_results' | translate"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ "inputs.housing_type." + item.key | translate }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ "inputs.housing_type." + item.key | translate }}
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-6">
          <div class="column-list">
            <label for="guarantee_marital_status" class="form-label">{{ "inputs.guarantee_marital_status" | translate }}</label>
            <ng-select
              formControlName="guarantee_marital_status"
              [items]="maritalStatusOptions"
              bindValue="key"
              [placeholder]="'inputs.select_option' | translate"
              [searchable]="true"
              [clearable]="false"
              [notFoundText]="'tables.no_results' | translate"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ "inputs.marital_status." + item.key | translate }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ "inputs.marital_status." + item.key | translate }}
              </ng-template>
            </ng-select>

            <label for="guarantee_employment_situation" class="form-label">{{
              "inputs.guarantee_employment_situation" | translate
            }}</label>

            <ng-select
              formControlName="guarantee_employment_situation"
              [items]="employmentOptions"
              bindValue="key"
              [placeholder]="'inputs.select_option' | translate"
              [searchable]="true"
              [clearable]="false"
              [notFoundText]="'tables.no_results' | translate"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ "inputs.employment_situation." + item.key | translate }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ "inputs.employment_situation." + item.key | translate }}
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="column-list">
            <label>{{ "inputs.guarantee_employer_tax_id" | translate }}</label>

            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                [value]="orderData.guarantee_employer_tax_id"
                #inputFieldclientEmployerTaxId
                formControlName="guarantee_employer_tax_id"
              />

              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="
                    copyToClipboard(inputFieldclientEmployerTaxId.value, $event)
                  "
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>
            <label for="guarantee_employer_from_date" class="form-label"
              >{{ "inputs.guarantee_employer_from_date" | translate }}
            </label>
            <div class="input-group">
              <mat-form-field appearance="fill">
                <input
                  matInput
                  [matDatepicker]="guarantee_employer_from_date"
                  formControlName="guarantee_employer_from_date"
                  placeholder="{{
                    'inputs.guarantee_employer_from_date' | translate
                  }}"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="guarantee_employer_from_date"
                ></mat-datepicker-toggle>
                <mat-datepicker #guarantee_employer_from_date></mat-datepicker>
              </mat-form-field>
            </div>
            <label>{{ "inputs.guarantee_employer_address" | translate }}</label>

            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                [value]="orderData.guarantee_employer_address"
                #inputFieldguarantee_employer_address
                formControlName="guarantee_employer_address"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="
                    copyToClipboard(
                      inputFieldguarantee_employer_address.value,
                      $event
                    )
                  "
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="column-list">
            <label>{{ "inputs.guarantee_employer_name" | translate }}</label>

            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                [value]="orderData.guarantee_employer_name"
                #inputFieldclientEmployerName
                formControlName="guarantee_employer_name"
              />

              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="
                    copyToClipboard(inputFieldclientEmployerName.value, $event)
                  "
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>

            <label>{{ "inputs.guarantee_mounthly_net_income" | translate }}</label>

            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                [value]="orderData.guarantee_monthly_net_income"
                #inputFieldclientMounthlyNetIncome
                formControlName="guarantee_monthly_net_income"
              />

              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="
                    copyToClipboard(
                      inputFieldclientMounthlyNetIncome.value,
                      $event
                    )
                  "
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>

            <label>{{
              "inputs.guarantee_employer_postal_code" | translate
            }}</label>

            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                [value]="orderData.guarantee_employer_postal_code"
                #inputFieldguarantee_employer_postal_code
                formControlName="guarantee_employer_postal_code"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="
                    copyToClipboard(
                      inputFieldguarantee_employer_postal_code.value,
                      $event
                    )
                  "
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="input-group justify-content-start mt-2">
          <button
            type="submit"
            class="btn btn-primary d-flex align-items-center gap-2"
            (click)="step = 1"
          >
            <i class="icon-arrow-left btn-next"></i>
            {{ "inputs.back" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

